import { z } from 'zod';
import { convertDelayToSeconds, getMaxDelayDescription, MAX_DELAY_SECONDS } from './delay-utils';
export const createFlowControlDelay1ConfigValidator = (isToolCall) => {
    const maxSeconds = isToolCall ? MAX_DELAY_SECONDS.toolCall : MAX_DELAY_SECONDS.postCall;
    const maxDelayDescription = getMaxDelayDescription(isToolCall);
    return z
        .object({
        timeDelayUnit: z.enum(['seconds', 'minutes', 'hours', 'days', 'weeks'], {
            error: (issue) => issue.input === undefined
                ? 'Time delay unit is required'
                : 'Time delay unit must be one of: seconds, minutes, hours, days, weeks'
        }),
        timeDelayValue: z
            .int('Time delay value must be a whole number')
            .min(1, 'Time delay value must be at least 1')
    })
        .refine((data) => {
        const { timeDelayUnit, timeDelayValue } = data;
        const totalSeconds = convertDelayToSeconds(timeDelayValue, timeDelayUnit);
        return totalSeconds <= maxSeconds;
    }, {
        path: ['timeDelayValue'],
        error: `Total delay time cannot exceed ${maxDelayDescription}`
    });
};
export const Flow_Control_Delay_1_ConfigValidator = createFlowControlDelay1ConfigValidator(false);
//# sourceMappingURL=flow-control-delay-1.js.map